import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { GetPlansRequest, Plan } from "../../domain";
import { PlansRepository } from "../../repositories";
import { BaseGridResponse } from "../../../data/shared/base-grid.response";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";

@Injectable({ providedIn: 'root' })
export class GetPlansUsecase implements UseCase<BaseRequest<GetPlansRequest>, BaseGridResponse<Plan>> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: BaseRequest<GetPlansRequest>): Observable<BaseGridResponse<Plan>> {
    return this.planRepository.getPlans(params);
  }

}
